import { FETCH_SCHEMA, DELETE_CONNECTION } from "../constants/actionTypes";
import * as api from "../api/index.js";
import { toast } from "react-toastify";
import { decryptData } from "../Components/utils/EncriptionStore";

const user = (() => {
  const encryptedData = localStorage.getItem("profile");
  return encryptedData ? decryptData(encryptedData) : null;
})();


export const fetchSchema = () => async (dispatch) => {
  try {
    const response = await api.fetchSchema({
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    });
    dispatch({
      type: FETCH_SCHEMA,
      payload: response.data,
    });
  } catch (error) {
    console.error("FETCH_SCHEMA error", error);
    toast.error(error.response?.data?.detail || "Failed to fetch schema.");
  }
};

export const deleteConnection = (formData) => async (dispatch) => {
  try {
    const res = await api.deleteConnection(formData);
    const { statusCode, content } = res?.data || {};

    if (statusCode === 200) {
      dispatch({
        type: DELETE_CONNECTION,
        payload: {
          name: formData.name,
          content: content || "Connection deleted successfully",
        },
      });
      toast.success(content || "Connection deleted successfully");
      return content;
    } else {
      const errorMsg = content || "Failed to delete connection.";
      toast.error(errorMsg);
      throw new Error(errorMsg);
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.detail || "Failed to delete connection.";
    console.error("DELETE_CONNECTION error:", error);
    toast.error(errMsg);
    throw new Error(errMsg);
  }
};
